// extracted by mini-css-extract-plugin
export default {"navLink":"navLink_navLink__VCakL","active":"navLink_active__8Lczm"};